import classNames from "classnames";
import Link from "next/link";
import { IBaseBox } from "../../model/base";
import styles from "./topPostComments.module.scss";
import Image from "next/legacy/image";
interface TopPostCommentsProps {
  posts: IBaseBox[];
}

export default function TopPostComments(props: TopPostCommentsProps) {
  const { posts } = props;
  return posts ? (
    <div className={styles["today-reading-index"]}>
      <div className={classNames(styles["title"], "d-flex align-items-center")}>
        <h2>Đọc gì hôm nay</h2>
      </div>
      <div className={styles["list-post"]}>
        {posts.map((post, index) => {
          const imageUrl = post?.image_src
            ? process.env.NEXT_PUBLIC_BASE_IMAGE_URL + `/articles/${post?.image_src}`
            : process.env.NEXT_PUBLIC_NO_IMAGE;
          return (
            <div key={index} className={styles["item"]}>
              <Link href={`/${post.alias}`} className={styles["thumb-image"]}>
                <Image src={imageUrl} alt={post?.title} layout="fill" objectFit="cover" quality={100} className="image" />
              </Link>
              <div className={styles["post-info"]}>
                <h3>
                  <Link href={`/${post.alias}`} title={post.title}>
                    {post.title}
                  </Link>
                </h3>
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 469.33 320">
                    <g>
                      <path d="M234.67,96a64,64,0,1,0,64,64A64,64,0,0,0,234.67,96Z" />
                      <path d="M234.67,0C128,0,36.91,66.35,0,160c36.91,93.65,128,160,234.67,160s197.76-66.35,234.66-160C432.43,66.35,341.44,0,234.67,0Zm0,266.67A106.67,106.67,0,1,1,341.33,160,106.71,106.71,0,0,1,234.67,266.67Z" />
                    </g>
                  </svg>
                  {post.article_view_counts?.count || 0} Lượt xem
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  ) : (
    <></>
  );
}
